import CustomPagination from '@/platform/common/components/CustomPagination/CustomPagination';
import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import {
    Button,
    Container,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Segment,
    SegmentContent,
    SegmentFooter,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@/platform/ui';
import {
    EllipsisVerticalIcon,
    PencilIcon,
    PlusIcon,
} from '@heroicons/react/24/outline';
import { Link, usePage } from '@inertiajs/react';
import Navigation from '../components/Navigation';

const IndexView = () => {
    const { auth, options } = usePage().props;

    return (
        <Container>
            <Navigation />

            <Segment>
                <SegmentHeader header='Vragenlijst opties'>
                    {auth.permissions.includes('update questionnaires') && (
                        <Button
                            variant='primary'
                            as={Link}
                            href='/questionnaires/options/create'
                        >
                            <PlusIcon className='size-5' />
                            Nieuwe vragenlijst optie
                        </Button>
                    )}
                </SegmentHeader>

                <SegmentContent>
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell>
                                    Standaard optie
                                </TableHeaderCell>
                                <TableHeaderCell textAlign='center'>
                                    Optie vertalingen
                                </TableHeaderCell>
                                <TableHeaderCell textAlign='center'>
                                    Optie beschrijving vertalingen
                                </TableHeaderCell>
                                <TableHeaderCell textAlign='right' />
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {options?.meta?.total === 0 && (
                                <NoDataRow numberOfColumns={4} />
                            )}

                            {options?.data?.map(option => (
                                <TableRow key={option.id}>
                                    <TableCell>
                                        {option?.label['nl'] || ''}
                                    </TableCell>
                                    <TableCell textAlign='center'>
                                        {Object.keys(option.label)
                                            ?.filter(lang => lang !== 'nl')
                                            ?.map(lang => (
                                                <Tooltip key={lang}>
                                                    <TooltipTrigger>
                                                        <img
                                                            src={`/flags/4x3/${lang === 'en' ? 'gb' : lang}.svg`}
                                                            alt={lang}
                                                            className='size-6'
                                                        />
                                                    </TooltipTrigger>
                                                    <TooltipContent side='left'>
                                                        {option.label[lang]}
                                                    </TooltipContent>
                                                </Tooltip>
                                            ))}
                                    </TableCell>
                                    <TableCell textAlign='center'>
                                        {Object.keys(option.description)?.map(
                                            lang => (
                                                <Tooltip key={lang}>
                                                    <TooltipTrigger className='not-first:ml-2'>
                                                        <img
                                                            src={`/flags/4x3/${lang === 'en' ? 'gb' : lang}.svg`}
                                                            alt={lang}
                                                            className='size-6'
                                                        />
                                                    </TooltipTrigger>
                                                    <TooltipContent side='left'>
                                                        {
                                                            option.description[
                                                                lang
                                                            ]
                                                        }
                                                    </TooltipContent>
                                                </Tooltip>
                                            )
                                        )}
                                    </TableCell>
                                    <TableCell textAlign='right'>
                                        {auth.permissions?.includes(
                                            'update questionnaires'
                                        ) && (
                                            <Menu>
                                                <MenuButton>
                                                    <EllipsisVerticalIcon className='size-5' />
                                                </MenuButton>
                                                <MenuItems anchor='bottom end'>
                                                    <MenuItem
                                                        as={Link}
                                                        href={`/questionnaires/options/${option.id}/edit`}
                                                        icon={PencilIcon}
                                                    >
                                                        Wijzigen
                                                    </MenuItem>
                                                </MenuItems>
                                            </Menu>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </SegmentContent>

                <SegmentFooter>
                    <CustomPagination meta={options?.meta} only={['options']} />
                </SegmentFooter>
            </Segment>
        </Container>
    );
};

export default IndexView;
